import { IGetPossibleAppointmentsResponse } from 'shared/repositories/announcements/v1/get-possible-appointments';

export function itemsFromFetchGetSpecialtiesSelector(
  state: IGetPossibleAppointmentsResponse,
): IGetPossibleAppointmentsResponse['items'] {
  return state.items;
}
